import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.identity-claims-admin';
import * as api from '../../../clients/api';

@Injectable()
export class ApiIdentityClaimsAdminEffects {

    IdentityClaimsAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_IDENTITY_CLAIMS_ADMIN),
        mergeMap((x: ac.GetIdentityClaimsAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIdentityClaimsAdmin().pipe(
                map((result: any) => {
                    return new ac.GetIdentityClaimsAdminErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIdentityClaimsAdminFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AccountService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AccountService {
        if (this.service === null) {
            this.service = this.injector.get(api.AccountService);
        }
        return this.service;
    }
}
